/**
 * THE RUBY TILL GEM -- the brand mark and every loader in super-admin.
 *
 * Export name and props are unchanged; the drawing now comes from the ONE
 * hosted Ruby Token asset through `<RubyToken>` (spec 2026-09-27 D10), so
 * the issue console, every `RubyLoader` and every button spinner render the
 * same file as platform-app. The old inline geometry survives only as
 * `<RubyToken>`'s fallback (`RubyGemInline`) for when the CDN is unreachable.
 *
 *  - `drawing` false -> the finished mark, static (logo use).
 *  - `drawing` true  -> the loading state: the glowing gem, sparks firing
 *    along its facets (`RubyGemGlow`; recoloured gems keep the cut loop).
 *
 * Brand rules (README): never recolour, rotate, gradient or drop-shadow the
 * gem. `color="currentColor"` is the one allowed exception -- the brand's
 * on-red / on-black finish, so a gem on a ruby button stays visible.
 */
import React from 'react';
import { RubyToken } from './RubyToken';

export interface RubyGemMarkProps {
  size?: number;
  drawing?: boolean;
  title?: string;
  style?: React.CSSProperties;
  /**
   * Ink colour. Ruby by default. Pass `currentColor` inside a coloured
   * button so the gem takes the button's text colour.
   */
  color?: string;
}

export const RubyGemMark: React.FC<RubyGemMarkProps> = ({ size = 24, drawing = false, title, style, color }) => (
  <RubyToken size={size} drawing={drawing} title={title} style={style} color={color} />
);

export default RubyGemMark;
